export function Map () {
  return {
    sop: window.sop,
    myMap: null,
    myMapCenter: null,
    center: [989640, 1817006],
    baseZoom: 2, // ZOOM 기본설정 레벨
    zoom: 2, // ZOOM 레벨
    minZoom: 1, // 최소 ZOOM 레벨
    maxZoom: 9, // 최대 ZOOM 레벨
    isScale: true, // 스케일컨트롤 표시 여부
    isPanControl: false, // 팬컨트롤 표시 유무
    isMeasureControl: true, // 측정컨트롤 표시 유무
    isCloseInfoWindowOnClick: false, // 지도클릭스 인포윈도우 닫기 유무
    isZoomSliderControl: false, // 줌 컨트롤 표시 유무

    defaultDataGeoJson: null,

    delegate: null,
    polygonGeoJsonArray: [],
    mapPolygonGeoJsonStyle: null,

    createMap: function (mapId, delegate, options) {
      if (delegate) {
        this.delegate = delegate
      }
      if (options !== undefined) {
        if (options.scale !== undefined) {
          // 스케일컨트롤 표시 유무
          this.isScale = options.isScale
        }
        if (options.panControl !== undefined) {
          // 팬컨트롤 표시 유무
          this.isPanControl = options.isPanControl
        }
        if (options.measureControl !== undefined) {
          // 측정컨트롤 표시 유무
          this.isMeasureControl = options.measureControl
        }
        if (options.closeInfoWindowOnClick !== undefined) {
          // 지도클릭스 인포윈도우 닫기 유무
          this.isCloseInfoWindowOnClick = options.closeInfoWindowOnClick
        }
        if (options.zoomSliderControl !== undefined) {
          this.isZoomSliderControl = options.zoomSliderControl
        }
      }

      // if (!this.mapPolygonGeoJsonStyle) {
      //   this.mapPolygonGeoJsonStyle = mapStyle.mapPolygonGeoJsonStyle()
      // }

      this.myMap = this.sop.map(mapId, {
        attributionControl: false,
        doubleClickZoom: false,
        measureControl: this.isMeasureControl,
        panControl: this.isPanControl,
        scale: this.isScale,
        zoomSliderControl: this.isZoomSliderControl,
        closeInfoWindowOnClick: this.isCloseInfoWindowOnClick
      })

      this.myMapCenter = this.sop.utmk(this.center[0], this.center[1])
      this.myMap.setView(this.myMapCenter, this.zoom)

      return this
    },

    setView: function (utmkCenter, zoom) {
      this.myMapCenter = utmkCenter
      this.zoom = zoom
      this.myMap.setView(this.myMapCenter, this.zoom)
    },

    setPolygonGeoJson: function (obj, onEachFeature, style) {
      this.defaultDataGeoJson = this.sop.geoJson(obj, {
        style: style,
        onEachFeature: onEachFeature
      }).addTo(this.myMap)
    },

    setPolygonGeoJsonStyle: function (style) {
      this.defaultDataGeoJson.setStyle(style)
    },

    addPolygonGeoJson: function (obj, onEachFeature, style) {
      const dataGeoJson = this.sop.geoJson(obj, {
        style: style,
        onEachFeature: onEachFeature
      }).addTo(this.myMap)

      this.polygonGeoJsonArray.push(dataGeoJson)
    },

    // defaultPolygonGeoJson: function (obj) {
    //   this.defaultDataGeoJson = this.sop.geoJson(obj, {
    //     style: () => {
    //       return {
    //         color: 'black',
    //         weight: 2,
    //         dashArray: '1',
    //         opacity: 1,
    //         fillOpacity: 0,
    //         fillColor: '#FFFFFF'
    //       }
    //     },
    //     onEachFeature: (feature, layer) => {
    //       layer.setStyle({
    //         fillColor: layer.options.fillColor,
    //         weight: layer.options.weight,
    //         color: layer.options.color,
    //         dashArray: layer.options.dashArray,
    //         fillOpacity: layer.options.fillOpacity
    //       })
    //
    //       layer.on({
    //         click: (event) => {
    //           if (this.delegate && this.delegate.onDefaultLayerClick) {
    //             this.delegate.onDefaultLayerClick(event)
    //           }
    //         }
    //       })
    //     }
    //   }).addTo(this.myMap)
    // },

    // addPolygonGeoJson: function (obj) {
    //   const dataGeoJson = this.sop.geoJson(obj, {
    //     style: this.mapPolygonGeoJsonStyle,
    //     onEachFeature: (feature, layer) => {
    //       layer.setStyle({
    //         fillColor: mapStyle.getStyleKoreaMapColor(layer.feature.properties.adm_cd),
    //         weight: layer.options.weight,
    //         color: layer.options.color,
    //         dashArray: layer.options.dashArray,
    //         fillOpacity: layer.options.fillOpacity
    //       })
    //
    //       layer.on({
    //         click: (event) => {
    //           if (this.delegate && this.delegate.onLayerClick) {
    //             this.delegate.onLayerClick(event)
    //           }
    //         }
    //       })
    //     }
    //   }).addTo(this.myMap)
    //
    //   this.polygonGeoJsonArray.push(dataGeoJson)
    // },

    resizeMap: function () {
      this.myMap._onResize()
    },

    reloadMap: function () {
      if (this.center) {
        this.myMapCenter = this.sop.utmk(this.center[0], this.center[1])
        this.myMap.setView(this.myMapCenter, this.zoom)
      }
    },

    removeAllAddPolygonLayer: function () {
      if (this.polygonGeoJsonArray) {
        this.polygonGeoJsonArray.forEach(dataGeoJson => dataGeoJson.remove())
      }
    },

    showCaption: function () {
      this.myMap.eachLayer(function (layer) {
        if (layer.feature) {
          const x = layer.feature.properties.x
          const y = layer.feature.properties.y
          layer.setCaption({
            title: layer.feature.properties.adm_nm,
            color: 'black',
            showAllZoomLevel: false
          }, [x, y])
        }
      })
    },

    removeCaption: function () {
      this.myMap.eachLayer(function (layer) {
        if (layer.feature) {
          layer.removeCaption()
          layer.captionObj = null
        }
      })
    },

    closeInfoWindow: function (infoWindow) {
      this.myMap.closeInfoWindow(infoWindow)
    },

    sopNewLatLng: function (latitude, longitude) {
      return new window.sop.LatLng(latitude, longitude)
    },

    setMapScrollWheelZoomDisable(isDisable) {
      if (isDisable) {
        this.myMap.scrollWheelZoom.disable()
      } else {
        this.myMap.scrollWheelZoom.enable()
      }
    },

    setMapDraggingDisable(isDisable) {
      if (isDisable) {
        this.myMap.dragging.disable()
      } else {
        this.myMap.dragging.enable()
      }
    },


    /******************************************************************************************
    * Map Event Function
    */
    addEventMapOnClick: function () {
      this.myMap.on('zoomstart', e => {
        if (this.delegate && this.delegate.didMapZoomStart) {
          this.delegate.didMapZoomStart(e)
        }
      })
    },
    addEventMapZoomStart: function () {
      this.myMap.on('zoomstart', e => {
        if (this.delegate && this.delegate.didMapZoomStart) {
          this.delegate.didMapZoomStart(e)
        }
      })
    },
    addEventMapZoomEnd: function () {
      this.myMap.on('zoomend', e => {
        if (this.delegate && this.delegate.didMapZoomEnd) {
          this.delegate.didMapZoomEnd(e)
        }
      })
    }

  }
}
